import { render, staticRenderFns } from "./EquipmentsCategorical.vue?vue&type=template&id=567c91e6"
import script from "./EquipmentsCategorical.vue?vue&type=script&lang=js"
export * from "./EquipmentsCategorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports